import script from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsEdit.vue?vue&type=style&index=0&id=1a87c420&lang=scss"

const __exports__ = script;

export default __exports__